import { withHTMLHeadSEO } from 'components/common';
import AssignmentDemo from 'components/common/assignment-demo/AssignmentDemo';

const SimulationEhrDemoPage = () => <AssignmentDemo />;

export { SimulationEhrDemoPage as BaseSimulationEhrDemoPage };
export default withHTMLHeadSEO({ title: 'Simulation EHR demo' })(SimulationEhrDemoPage);
